export default function ContentTenth({ verticalTabsState }) {
  return (
    <div
      className={`content-10 overflow-hidden max-h-0 transition-opacity duration-[0.2s] ease-linear ${
        verticalTabsState === 10
          ? "max-h-[5000px] opacity-100 z-2"
          : "opacity-0 max-h-0 z-0"
      }`}
    >
      <h1 className="font-mont text-[36px] leading-[40px] my-[0.67em]">
        <strong>
          Smart Point Of Sale
        </strong>
      </h1>

      <p className="text-[18px] leading-[28px] mb-[25px]">
        Run your bar or restaurant efficiently.
      </p>

      <h2 className="text-[30px] leading-[40px] font-mont mt-5 mb-[10px]">
        <strong>An Interface Designed For Productivity</strong>
      </h2>

      <p className="text-[18px] leading-[28px] mb-[25px]">
        Spend less time at the counter, be there for your customers.
      </p>

      <div className="pl-[15px]">
        <h2 className="text-[30px] leading-[40px] font-mont mt-5 mb-[10px]">
          <strong>A God-eye's View On Your Restaurant</strong>
        </h2>

        <p className="my-5 text-[16px]">
          With the floors & tables manager.
        </p>

        <p className="mb-5 text-[16px]">
          <strong>MEAN3 Restaurant</strong> lets you quickly overview your
          restaurant and jump from floor to floor to your table's orders.
        </p>

        <p className="mb-5 text-[16px]">
          <strong>The floor plan</strong> will tell you exactly where are your
          customers, where are the free tables, who is still waiting for food, how much room do you have left.
        </p>

        <p className="mb-5 text-[16px]">Fully customizable floor plan</p>

        <p className="mb-5 text-[16px]">Supports multiple POS</p>

        <p className="mb-5 text-[16px]">Floor plan entirely optional</p>

        <p className="mb-5 text-[16px]">Can be configured on a POS basis</p>
      </div>

      <h2 className="text-[30px] leading-[40px] font-mont mt-10 mb-[10px]">
        <strong>Compatible With Any Hardware</strong>
      </h2>

      <p className="text-[18px] leading-[28px] mb-[25px]">
        No installation and no specific hardware required.
      </p>

      <h2 className="text-[30px] leading-[40px] font-mont mt-5 mb-[10px]">
        <strong>Online Or Offline</strong>
      </h2>

      <p className="text-[16px] my-[10px] leading-[20px]">
        MEAN3's Point of Sale stays reliable even if your connection is not.
      </p>

      <p className="mb-5 text-[16px]">
        As a Web Application, MEAN3 Restaurant does not require any
        installation. It just works online. While an Internet connection is
        required to start the Point of Sale, it will stay operational even after
        complete disconnection.
      </p>

      <h2 className="text-[30px] leading-[40px] font-mont mt-5 mb-[10px]">
        <strong>Integrated Inventory Management</strong>
      </h2>

      <p className="text-[16px] my-[10px] leading-[20px]">
        Real time control & accurate forecasts to manage procurements.
      </p>

      <p className="mb-5 text-[16px]">
        Mean3 ERP automatically inputs any transaction from the POS in the
        stock. You can see in real time the availability of products without
        losing time. You won't need to setup separate stocks for the two apps
        and be a truly multi-channel business, without headache.
      </p>
    </div>
  );
}
